export const ACCEPTED_LANGUAGES = ['en-EN', 'es-ES', 'cn-CN']

export const POLLING_INTERVAL = 120000

